import { getTemplates } from "@/services/project/flowsheets"
import { useRequest } from "ahooks"
import { Space } from "antd"
import classNames from "classnames"
import styles from "./index.module.less";
import { CloseOutlined } from "@ant-design/icons"

interface TemplateFormItemProps {
  value?: number
  onChange?: (val: number | undefined) => void
  pId: string
}

export const TemplateFormItem = (props: TemplateFormItemProps) => {
  const {pId, value, onChange} = props
  const {data: templates = [], run, loading} = useRequest(() => getTemplates(pId))
  if (loading) return;

  const onClick = (tpl) => {
    onChange?.(value === tpl.id ? undefined : tpl.id)
  }

  const deSelect = () => {
    onChange?.(undefined)
  }

  return <Space wrap>
    {templates?.map((tpl, idx) => {
      return <div
        key={tpl.id}
        onClick={() => onClick(tpl)}
        className={classNames(value === tpl.id && styles.active)}
        style={{
          border: '1px solid #eee',
          borderRadius: 12,
          background: '#fff',
          position: 'relative',
        }}
      >
        {value === tpl.id && <div style={{
          position: 'absolute',
          right: -8,
          top: -8,
          border: '1px solid red',
          borderRadius: '50%',
          width: 24,
          height: 24,
          textAlign: 'center',
          color: 'red',
          backgroundColor: '#fff',
          cursor: 'pointer'
        }}
        onClick={deSelect}
        ><CloseOutlined /></div>}
        <div
          style={{
            background: '#fafbfc',
            borderRadius: 10,
            padding: 12,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={'/images/default.jpg'}
            alt={tpl.name}
            style={{ maxWidth: 100, maxHeight: 100, objectFit: 'contain' }}
          />
        </div>
        <div style={{ marginTop: 8, fontWeight: 500 }}>{tpl.name}</div>
      </div>
    })}
  </Space>
}